// extracted by mini-css-extract-plugin
export var attachmentContainer = "_ns-0";
export var fileList = "_ns-2";
export var removeFileButton = "_ns-1";